import comp from "./PostDetail";
export default comp;
